import * as React from "react";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Stack } from "@mui/system";

import { ReactComponent as Close } from "../../../Assets/Images/Close.svg";
import useOverlayState from "../../../Utils/Hooks/useOverlayState";
import ConfirmDialog from "../../organisms/ConfirmDialog/ConfirmDialog";
import { HorizontalDivide } from "../HorizontalDivide/HorizontalDivide";
import { NoRecordsFound } from "../NoRecordsFound/NoRecordsFound";
import CircularSpinner from "../Spinner/CircularSpinner/CircularSpinner";
import { Heading2, Heading4 } from "../Typography/Heading/Heading";

export const SideDrawer = ({
  openDrawer,
  anchorDrawer,
  children,
  close,
  width,
  headingText,
  headingmarginLeft,
  formDefaultValues,
  newFormValues,
  isBold,
  isDirty, // has user modifies any of the inputs.
  isLoading, // if form is waiting for api calls
  isError, // if any dependant api call(s) has caused any errors
}) => {
  const { closeOverlay, OverlayState, openOverlay } = useOverlayState();

  const onClose = React.useCallback(() => {
    // warn user when he try to close drawer when there are form changes

    // method 1 : send old/default values and latest values
    if (formDefaultValues && newFormValues) {
      const isObjectsAreSimilar =
        JSON.stringify(formDefaultValues) === JSON.stringify(newFormValues);
      if (isObjectsAreSimilar) {
        close();
      } else {
        openOverlay({ OverlayName: "confirm" });
      }
    }
    // method 2 : send in built react-hook-form isDirty flag to compare
    else if (isDirty) {
      openOverlay({ OverlayName: "confirm" });
    } else {
      close();
    }
  }, [isDirty, formDefaultValues, newFormValues]);

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom" ? "auto" : width || "auto",
        padding: "0 24px",
      }}
      role="presentation"
    >
      <br />
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        ml={headingmarginLeft || "auto"}
      >
       {isBold?<Heading2 text={headingText}/>:<Heading4 text={headingText} />}
        <Close
          role="img"
          type="img"
          aria-label="Close Icon"
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            close();
          }}
        />
      </Stack>
      <HorizontalDivide marginTop={"12px"} marginBottom={"12px"} />
      {isLoading ? (
        <div
          style={{
            marginTop: "50%",
          }}
        >
          <CircularSpinner />
        </div>
      ) : isError ? (
        <NoRecordsFound
          isError={isError}
          textPosition={"start"}
          textColor={"black"}
          borderRadius={"4px"}
          borderColor={"#CCE4FF"}
          padding={"8px"}
          addBorder={true}
        />
      ) : (
        children
      )}
    </Box>
  );

  return (
    <Drawer
      style={{
        position: "absolute",
        zIndex: 1,
      }}
      anchor={anchorDrawer}
      open={openDrawer}
      onClose={onClose}
    >
      <div
        style={{
          height: "100%",
        }}
      >
        {list(anchorDrawer)}
      </div>
      {OverlayState.visible && (
        <ConfirmDialog
          title="Unsaved Changes"
          description="You are about to close the drawer. All changes will be lost. Do you really want to leave without saving?"
          open={OverlayState?.visible}
          onCancelClick={() => {
            closeOverlay();
          }}
          close={() => {
            closeOverlay();
          }}
          onOkClick={() => {
            close();
            closeOverlay();
          }}
        />
      )}
    </Drawer>
  );
};
